module.exports = __webpack_public_path__ + "img/frase.934190ec.jpg";